module.exports = __webpack_public_path__ + "static/p09_pajaroLalaR-9ddc996ac85ba809877d62a3c06c1d28.png";